<template>
    <div
        class="coordinates"
        v-show="
            store.state.currentScreen === 'my-phaser-container' &&
            store.state.showCoordinates &&
            !store.state.pattern.noColumns
        "
    >
        {{ store.state.coordinates }}
    </div>
</template>

<script>
export default {
}
</script>

<style lang="scss">
.coordinates {
    user-select: none;
    position: absolute;
    top: calc(min(950px, 100vh - 50px));
    left: calc(min(1700px, 100vw - 100px));
    z-index: 1;
}
</style>